/* istanbul ignore file */

export class DismissedSiteDataPreviewConfigurationMessage {
    dismissedDate: string;
    isDismissed: boolean;
}
